import React, {useState} from "react";
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { useRecoilState, useRecoilValue } from 'recoil';

import { Globals } from "root/DataFunctions/BaseDataFns";
import { childThemeState } from 'root/recoil/childThemeState';
import { childDrawerState } from 'root/recoil/childDrawerState';
import { childDetailsState } from 'root/recoil/childDetailsState';
import useModalViewChildContact from "root/Modals/ViewChildContact/useModalViewChildContact";

import Logo from '../assets/images/arclogo.png';
import gallery from '../assets/icons/gallery.png';

import '../styles/navbar.scss';
import '../styles/Modals/childContact.scss';

const Navbar = () => {
    const childTheme = useRecoilValue(childThemeState);
    const childDetails = useRecoilValue(childDetailsState);
    const [childDrawer, setChildDrawer] = useRecoilState(childDrawerState);
    const [renderAddPostModal, showAddPostModal] = useModalViewChildContact();

    let avatarUrl = '/images/defaultPerson.jpg';

    if (childDetails) {
        avatarUrl = childDetails[0].document_id === null
        ?
        Globals.APIFolder + '/user/' + childDetails[0].adoptee_user_id + '/avatar?thumb&size=100'
        :
        Globals.APIFolder + '/images/' + childDetails[0].document_id + '?thumb&size=100';
    }

    const url = Globals.BaseURL + "/images/themes/" + childTheme.banner;

    const handleShowAddPostModal = (e) => {
        showAddPostModal(childDetails);
    }

    let theme = childTheme ? { backgroundImage: `url(${url})` } : {} ;

    return(
        <div className='nav-container' >
        <nav className='navbar nav-body' style={ theme }>
            {renderAddPostModal()}
            <div className="navbar_inner">
                <div className="navbar_logo">
                    <Link to="/child">
                        <img className="img" src={Logo} alt="Logo" />
                    </Link>
                </div>
                <div className="navbar_menu">
                    <div className="navbar_personal">
                        <div className='navbar_theme' >
                            <button
                                className="button"
                                onClick={() => setChildDrawer(!childDrawer)}
                            >
                                <img 
                                    className="icon"
                                    src={gallery} 
                                    alt="Navbar gallery icon"
                                    title={'Change Background'}
                                />
                            </button>
                        </div>
                        <Dropdown className="navbar_account_dropdown" >
                            <Dropdown.Toggle size="lg" variant="white">
                                <div className="navbar_account_dropdown_image">
                                    <img 
                                        className="icon"
                                        src={avatarUrl}
                                        title={'My Account'}
                                    />
                                </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    {childDetails && childDetails[0].adopted_firstname !== null  && childDetails[0].adopted_firstname !== '' && childDetails[0].adopted_firstname}
                                    {childDetails && (childDetails[0].adopted_firstname === null || childDetails[0].adopted_firstname === '')  && childDetails[0].firstname}
                                </Dropdown.Item>
                                <hr style={{margin: "0"}} />
                                <Dropdown.Item onClick={(e)=>handleShowAddPostModal(e)}>
                                    Contact
                                </Dropdown.Item>
                                <Dropdown.Item href="/arcom">Sign Out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>



                    </div>
                </div>

            </div>
        </nav>
        </div>
    )
}

export default Navbar;